import { HIGHLIGHT_ROUTE, UNHIGHLIGHT_ROUTE } from '../actions'
import { UPDATE_LIST } from '../../../integrations/list'

/**
 * @typedef {number|null} HighlightState ID of a highlighted route
 */

/**
 * @param {HighlightState} initialState
 * @returns {(state: HighlightState, action: Object) => HighlightState}
 */
export default function highlightReducer(initialState) {
    return (state = initialState, action) => {
        switch (action.type) {
            case HIGHLIGHT_ROUTE:
                return action.routeId

            case UNHIGHLIGHT_ROUTE:
                return null

            case UPDATE_LIST:
                // Remove highlight if not in the list anymore
                return (state && action.items.includes(state)) ? state : null

            default:
                return state
        }
    }
}
